import React from 'react';
import classNames from 'classnames';
import { IParticipantsPair, IParticipant, IScores } from 'twain-sport-fe-mono/interfaces';
import { loopPair } from 'twain-sport-fe-mono/utils';
import { Avatar } from '../Avatar';
import { ParticipantCard } from './ParticipantCard';
import { ParticipantScore } from './ParticipantScore';
import { RngResults } from '../RngResults';
import { ParticipantInfo } from './ParticipantInfo';
import classes from './Participants.module.scss';

interface IProps {
    participants: IParticipantsPair;
    scores?: IScores;
    live: boolean;
    onVideo?: boolean;
    withAvatar?: boolean;
    onClick?(code: string): void;
    scoreWithoutAnimation?: boolean;
    className?: string;
    isRng?: boolean;
}

const defaultProps: Partial<IProps> = {
    scores: {},
    withAvatar: true,
};

export const Participants: React.FC<React.PropsWithChildren<IProps>> = (props) => {
    const render = (participants: IParticipantsPair) => {
        if (props.isRng) {
            const results = {
                left: props.scores[participants.left.code],
                right: props.scores[participants.right.code],
            };
            return (
                <>
                    <ParticipantCard className={classes.card}>
                        <ParticipantInfo participant={participants.left} rngCourt="left" />
                    </ParticipantCard>
                    <RngResults results={results} itemClassName={classes.rngScore} />
                    <ParticipantCard className={classes.card} reverse>
                        <ParticipantInfo participant={participants.right} rngCourt="right" />
                    </ParticipantCard>
                </>
            );
        }
        return loopPair<IParticipant>(props.participants).map((participant, index) => (
            <ParticipantCard
                key={participant?.code || index}
                className={classes.card}
                participantCode={participant?.code}
                oneLineNickname={props.onVideo}
                withAvatar={props.withAvatar}
                onClick={props.onClick}
            >
                <ParticipantInfo participant={participant} />
                {props.withAvatar && (
                    <div className={classes.avatar}>
                        {props.live ? (
                            <ParticipantScore
                                value={props.scores[participant?.code] || 0}
                                withoutAnimation={props.scoreWithoutAnimation}
                            />
                        ) : (
                            <Avatar
                                size={props.onVideo ? 'small' : 'normal'}
                                src={participant?.avatarPictureUrl}
                                className={classNames({
                                    [classes.avatarImg]: !props.onVideo,
                                })}
                            />
                        )}
                    </div>
                )}
            </ParticipantCard>
        ));
    };

    return (
        <div
            className={classNames(
                classes.container,
                { [classes.transparent]: props.onVideo },
                props.className,
            )}
        >
            {render(props.participants)}
        </div>
    );
};

Participants.defaultProps = defaultProps;
